import Oidc, { UserManager } from "oidc-client";
export class Authenticator {
    constructor(config) {
        this.events = {};
        Oidc.Log.logger = console;
        Oidc.Log.level = Oidc.Log.INFO;
        this.userManager = new UserManager(config);
        this.userManager.events.addUserSignedOut(() => {
            this.user = undefined;
        });
        this.userManager.events.addUserSignedIn(() => {
        });
    }
    // async isTokenExpired(): Promise<boolean> {
    //     const user = await this.userManager.getUser();
    //     // if logged out, token cannot be experired.
    //     if (typeof user === "undefined") return;
    //     if (user == null) return;
    //     return user.expired;
    // }
    // async getUser(): Promise<User> {
    //     return await this.userManager.getUser();
    // }
    async getAccessToken() {
        if (typeof this.user === "undefined") {
            this.user = await this.userManager.getUser();
        }
        if (this.user.expired)
            throw new Error("Access token expired.");
        return this.user.access_token;
    }
    async isSignedIn() {
        if (typeof this.user === "undefined") {
            this.user = await this.userManager.getUser();
        }
        // if logged out, token cannot be experired.
        if (typeof this.user === "undefined")
            return false;
        if (this.user == null)
            return false;
        if (this.user.expired)
            return false;
        return true;
    }
    // async startSignin(url: string) {
    //     const user = await this.userManager.getUser();
    //     if (!user || user.expired) {
    //         if (typeof (Storage) !== "undefined") {
    //             localStorage.setItem("redirect-url", url);
    //         }
    //         await this.userManager.signinRedirect({ useReplaceToNavigate: true });
    //         this.raise("login");
    //     }
    // }
    // async completeSignin(): Promise<string> {
    //     await this.userManager.signinRedirectCallback();
    //     if (typeof (Storage) !== "undefined") {
    //         return localStorage.getItem("redirect-url");
    //     }
    //     return undefined;
    // }
    async signinSilent() {
        let user = await this.userManager.getUser();
        if (!user || user.expired) {
            user = await this.userManager.signinSilent({ useReplaceToNavigate: true });
        }
        if (!user || user.expired) {
            throw new Error("could not do silent signin");
        }
        return user;
    }
    async signinSilentCallback() {
        await this.userManager.signinSilentCallback();
    }
    async logout() {
        await this.userManager.removeUser();
    }
}
